module.exports = __webpack_public_path__ + "media/images/ico-rec-d7be9799.svg";